import { useRef } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import Backup from 'shared/icons/Backup';
import { FormError } from '@components/form-error';

export default observer(({ file, error, onChange, disabled }) => {
  const inputRef = useRef(null);

  const uploadClick = () => inputRef.current.click();
  const changeFile = (e) => {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;
    onChange(file);
  };

  return (
    <>
      <UploadContainer
        onClick={disabled ? null : uploadClick}
        filled={file !== null}
        error={error}
        disabled={disabled}
      >
        <UploadBox filled={file !== null} />
        {file !== null && <div>{file.name}</div>}
      </UploadContainer>
      <FormError text={error} />
      <input style={{ display: 'none' }} type="file" ref={inputRef} onChange={changeFile} />
    </>
  );
});

const UploadBox = styled(Backup)`
  margin: 0 16px;
  fill: ${(p) => (p.filled ? '#fff' : p.theme.textColor)};
`;

const UploadContainer = styled.div`
  display: flex;
  justify-content: ${(p) => (p.filled ? 'flex-start' : 'center')};
  background-color: ${(p) => (p.filled ? p.theme.textColor : 'inherit')};
  color: #ffffff;
  font-size: 11px;
  font-weight: bold;
  line-height: 13px;
  align-items: center;
  height: 37px;
  width: 100%;
  border: 1px solid ${(p) => (p.error ? p.theme.errorColor : p.theme.textColor)};
  border-radius: 4px;
  ${(p) => p.disabled && 'opacity: 0.65;'};

  :hover {
    cursor: ${(p) => (p.disabled ? 'auto' : 'pointer')};
  }
`;
